import styled from 'styled-components';

const PlainLink = styled.a`
  color: ${props => props.theme.colors.link};

  &:hover,
  &:active {
    color: ${props => props.theme.colors.linkActive};
    text-decoration: underline;
  }
`;

export default PlainLink;
